import { PRESCREENER_RESET_OBJECT } from 'client-portal/utils/prescreener/constants';
import { STEP_IDS } from 'client-portal/services/widget-steps';
import { action, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { sortOfficesByPlacement } from 'client-portal/utils/clinicianSearch/facet-catalog';
import RequestBaseRoute from './base';
import classic from 'ember-classic-decorator';

@classic
export default class RequestLocation extends RequestBaseRoute {
  @service analytics;
  @service session;
  @service mixpanel;
  @service store;
  @service request;
  @service geolocation;
  @service pendingAppointment;
  @service clientTimezone;
  @service clinicianSearch;

  templateName = '-request/location';
  stepId = STEP_IDS.SELECT_LOCATION;

  beforeModel(transition) {
    this.clientTimezone.reset();
    this.clinicianSearch.preselection.beginStep(transition);

    let reservation = this.modelFor(this.request.baseRouteName);
    if (!reservation.belongsTo('cptCode').id()) {
      this.request.transitionTo(this, 'service');
    }
  }

  async model(params, transition) {
    let reservation = this.modelFor(this.request.baseRouteName);

    let model = await this.clinicianSearch.preselection.modelForLocationStep(
      reservation,
      transition
    );
    if (model) {
      return model;
    }

    if (params.officeId) {
      transition.trigger(false, 'preselectionLoading');
    }

    let filter = {};
    let { officeId, searchByOffice } = transition.to.queryParams;
    if (searchByOffice) {
      filter = { id: officeId };
    } else {
      let clinicianId = reservation.get('clinician.id');
      let cptCodeId = reservation.get('cptCode.id');
      filter = { filter: { clinicianId, cptCodeId } };
    }

    return {
      geo: false,
      offices: await this.store.query('office', filter),
    };
  }

  afterModel(model, transition) {
    super.afterModel(...arguments);

    if (model.offices && !model.offices.length) {
      return this.request.transitionTo(this, 'unavailable', {
        queryParams: { reason: 'location unavailable' },
      });
    }

    if (this.clinicianSearch.preselection.skipStepIfActive('location', model.offices, transition)) {
      return;
    }
    if (this.skipStepWithPreselection(model.offices, transition, 'officeId')) {
      return;
    }

    this.setupModel(model);
    this.pendingAppointment.reset();
  }

  async setupModel(model) {
    try {
      if (navigator.geolocation && model.offices.length > 1) {
        let geolocation = this.geolocation;

        let position = await geolocation.getCurrentPosition();

        model.offices.forEach(office => {
          if (office.get('geolocation')) {
            let distance = geolocation.findDistanceTo(office.get('geolocation'), position);
            office.setProperties({ distance });
          }
        });

        setProperties(model, {
          geo: model.offices.some(x => !x.isVideo && x.isPublic),
          offices: sortOfficesByPlacement(model.offices),
        });
      }
    } catch (err) {
      // noop
    }
  }

  @action
  nextStep(office, params) {
    this.clinicianSearch.preselection.next({ office });
    super.nextStep('office', office, 'date', params);
  }

  @action
  didTransition() {
    let reservation = this.modelFor(this.request.baseRouteName);
    reservation.setProperties({
      office: null,
      startTime: null,
      clientType: null,
      message: null,
      hasCompletedMessageStep: false,
      channelFields: null,
      channelUploads: null,
      channelUploadsComplete: null,
      hasCompletedInformationStep: false,
      ...PRESCREENER_RESET_OBJECT,
    });

    this._trackAppointmentStep(reservation);
    return true;
  }
}
